// What the phone bar's button on Book & pay says and where it goes: the first
// thing still to do, in screen order. Pure, so it is pinned by
// booking-bar-target.test.mjs.
//
// It was always "Book" and always went to the address fields, past an empty
// car size and date, so every phone Pay refusal since 7 Oct followed a bar
// tap that skipped an empty field; and with everything filled in it went to
// the address fields again, not to the button (replay 01a11c1e: an Android
// visitor filled everything, tapped the bar twice and never saw Pay).
// Robin, 9 Oct 2026: "the book button is coming a bit early as we dont have
// the details". So the button names the next step and is never "Book".
// docs/BOOKING_QA_2026-10-09.md
import { fields } from '../store/constants/fields.js'
import { locationProblem } from './car-location.js'
import { isValidUkMobile } from './mobile.js'

// The Car location and mobile, right above the pay buttons.
export const PAY_FIELDS = '[data-book-pay-fields]'
// The bottom of the pay buttons (StepBook's zero-height marker).
export const PAY_BUTTONS_END = '[data-book-section="pay_buttons"]'

// The detail boxes in screen order, with the id each input carries. The one
// Car location box stands for the postcode and house number (25 Oct 2026,
// lib/car-location.js): done when picked, or typed with its postcode and a
// house.
const DETAILS = [
  [fields.carLocation, (value, values) => !locationProblem(values)],
  [fields.mobile, value => isValidUkMobile(String(value || '').trim())]
]

// { target: 'car_size' | 'date' | 'details' | 'pay', label, selector,
//   block: 'center' | 'start' | 'end', focusId }
// `total` is the live total as the customer reads it ("£95").
// v3: Form v3's order (lib/form-version.js; not with the wallet sheet's
// address): the car, then its location, then the day, then the mobile. The
// size may still be hidden behind the Registration box, so that step is
// "Add your car"; a detail box is scrolled to itself.
export const barTarget = (values, total = '', v3 = false) => {
  if (!values?.[fields.carSize]) {
    return { target: 'car_size', label: v3 ? 'Add your car' : 'Choose size', selector: `[data-book-field="${fields.carSize}"]`, block: 'center', focusId: null }
  }
  const firstEmpty = DETAILS.find(([name, ok]) => !ok(values[name], values))
  const details = firstEmpty && { target: 'details', label: 'Add your details', selector: v3 ? `#book-${firstEmpty[0]}` : PAY_FIELDS, block: v3 ? 'center' : 'start', focusId: `book-${firstEmpty[0]}` }
  if (v3 && details && firstEmpty[0] !== fields.mobile) return details
  if (!values?.[fields.date]) {
    return { target: 'date', label: 'Pick a day', selector: `[data-book-field="${fields.date}"]`, block: 'center', focusId: null }
  }
  if (details) return details
  return { target: 'pay', label: total ? `Pay ${total}` : 'Pay', selector: PAY_BUTTONS_END, block: 'end', focusId: null }
}
